import { useLocation } from 'preact-iso';
import { useLayoutEffect } from 'preact/hooks';
import toast from 'react-hot-toast';
import waitForTimers from 'wait-for-timers';
import TopNav from '../../components/top-nav';
import { useUser, useUserActions } from '../../global-state/user';
import { usePageTitle } from '../../utils/page-title';
import style from '../sign-in/style.module.scss';

const UpdatePassword = () => {
  usePageTitle('Update Password');
  const user = useUser();
  const { updatePassword } = useUserActions();
  const { route } = useLocation();

  useLayoutEffect(() => {
    if (!user) {
      console.warn('Not initially signed-in...');
      // Wait a seconds for sign-in to succeed. Otherwise, redirect
      return waitForTimers(['ric', 1000], () => {
        toast.error(
          `Sorry, you must be signed-in or use a new reset-password link to update your password.`,
          {
            duration: 10 * 1000,
          }
        );
        route('/sign-in');
      });
    }
  }, [user]);

  const onUpdatePassSubmit = (event: Event) => {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const data = new FormData(form);
    const password = data.get('password') as string;
    const passwordConfirmed = data.get('password_confirmed') as string;

    if (password !== passwordConfirmed) {
      toast.error(`Passwords don't match`);
      return;
    }

    updatePassword(password).then(
      () => {
        toast.success('Password updated!');
        route('/now');
      },
      (error) => {
        toast.error(`Failed to update password: ${error}`);
      }
    );
  };

  return (
    <>
      <TopNav />
      <div class="top-section">
        <h1 class={style.heading}>Update Password</h1>

        {/* @ts-ignore */}
        <form
          class={`${style.form} mx-auto w-96 max-w-full`}
          onSubmit={onUpdatePassSubmit}
        >
          <label>
            <span>Email Address</span>
            <input
              name="email"
              type="email"
              autoComplete="email"
              value={user ? user.email : ''}
              disabled
            />
          </label>
          <label>
            <span>New Password</span>
            <input
              name="password"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
            />
          </label>
          <label>
            <span>Confirm New Password</span>
            <input
              name="password_confirmed"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
            />
          </label>
          <button class="button button--submit" type="submit">
            Update Password
          </button>
        </form>
      </div>
    </>
  );
};

export default UpdatePassword;
